import React, { Component } from 'react';

class ImportResults extends Component{
    constructor(props){
        super(props)
        this.state = {
            loading: false,
            currentPage: 1,
            leftIndex: 0,
            rightIndex: 0
        }
    }

    componentDidMount(){
        //Right index initialization
        this.setState({
            rightIndex: this.props.itemsPerPage,
            loading: false
        });
    }

    prevPage = () => {
        const rightIndex = this.state.leftIndex;
        const leftIndex = this.returnMinLeftIndex(this.state.leftIndex - this.props.itemsPerPage)

        this.setState({
            leftIndex: leftIndex,
            rightIndex: rightIndex,
            currentPage: this.state.currentPage === 1 ? 1 : this.state.currentPage - 1
        })
    }

    nextPage = () => {
        const leftIndex = this.state.rightIndex;
        const rightIndex = this.returnMaxRightIndex(leftIndex + this.props.itemsPerPage);

        this.setState({
            leftIndex: leftIndex,
            rightIndex: rightIndex,
            currentPage: this.state.currentPage + 1
        })
    }

    // Gets the highest right index (based on the max length of array)
    returnMaxRightIndex = (testIndex) => {
        return testIndex > this.props.results.length ? this.props.results.length : testIndex;
    }

    // Gets the lowest index, forcing 0 to be the minimum
    returnMinLeftIndex = (testIndex) => {
        return testIndex < 0 ? 0 : testIndex;
    }

    render(){
        const { results } = this.props;
        const { currentPage, leftIndex, rightIndex } = this.state;

        return (
            <React.Fragment>
                {/* Pagination */}
                <div className="customer-search-items-pagination assigned-products">
                    <button disabled={currentPage === 1} onClick={() => this.prevPage()}> 
                        <div className="icon-backward"></div>
                        Prev
                    </button>
                    <div className="customer-search-items-pagination-page">{currentPage + ' - ' + (Math.floor((results.length - 1) / 10 + 1))}</div>
                    <button disabled={rightIndex >= results.length} onClick={() => this.nextPage()}>
                        Next
                        <div className="icon-forward"></div>
                    </button>
                </div>

                {/* Results Log */}
                <div className="csv-results"> 
                    {results.slice(leftIndex, rightIndex).map((item, index) => {
                        return <div key={index}><span>{item[0]}</span>{" - " + item[1]}</div>
                    })}
                </div>
            </React.Fragment>
        )
    }
}

export default ImportResults;


// WEBPACK FOOTER //
// ./src/components/admin/top-tiers/importer/ImportResults.js